module.exports = __webpack_public_path__ + "static/img/fish31.3c7eaca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jiejifish/fish31.png
// module id = Rxch
// module chunks = 0